import Parent from 'embed/services/Parent'
import {
  DataLayerGetter,
  GoogleAnalyticsEvent,
  GoogleAnalyticsEventTypes,
  GoogleAnalyticsPageview,
  GtagClientGetter,
} from './types'
import { getDataLayerFromWindow, getGtagClientFromWindow, gtagEventConfigFromEvent } from './utils'

export interface Config {
  clientGetter?: GtagClientGetter
  dataLayerGetter?: DataLayerGetter
}

export class GoogleTagManagerService {
  clientGetter: GtagClientGetter = getGtagClientFromWindow

  dataLayerGetter: DataLayerGetter = getDataLayerFromWindow

  publishToParent = false

  get client(): ReturnType<GtagClientGetter> {
    return this.clientGetter()
  }

  get dataLayer(): ReturnType<DataLayerGetter> {
    return this.dataLayerGetter()
  }

  constructor(config?: Config) {
    if (typeof config?.clientGetter === 'function') {
      this.clientGetter = config.clientGetter
    }
    if (typeof config?.dataLayerGetter === 'function') {
      this.dataLayerGetter = config.dataLayerGetter
    }
  }

  sendEvent(event: GoogleAnalyticsEvent) {
    this.client?.('event', event.action, gtagEventConfigFromEvent(event))

    if (this.publishToParent === true) {
      Parent.publishMessage(GoogleAnalyticsEventTypes.Event, event)
    }
  }

  sendPageview(pageview: GoogleAnalyticsPageview) {
    this.client?.('event', 'page_view', gtagEventConfigFromEvent(pageview))

    if (this.publishToParent === true) {
      Parent.publishMessage(GoogleAnalyticsEventTypes.Pageview, pageview)
    }
  }
}
